/**
 * Session 3a — shared helpers for the 17 bespoke pages built in
 * PRs 3-19. Tones / formatters / trace messages live here so the
 * page files stay focused on layout + content.
 */

export function severityChip(
  level: "neutral" | "info" | "attention" | "critical" | "veto",
): string {
  switch (level) {
    case "critical":
      return "bg-rose-100 text-rose-800";
    case "attention":
      return "bg-amber-100 text-amber-800";
    case "info":
      return "bg-brand-blue/10 text-brand-deep";
    case "veto":
      return "bg-purple-100 text-purple-800";
    default:
      return "bg-slate-100 text-slate-700";
  }
}

export function formatSar(amount: number | null | undefined): string {
  if (amount === null || amount === undefined) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatPct(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return `${value.toFixed(0)}%`;
}

export function daysAgo(iso: string): number {
  const d = new Date(iso);
  return Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
}

/**
 * Show a trace explanation in the global TraceExplainerHost popover.
 *
 * Session 3a.5 FOLLOWUP PR 3 — replaces the previous window.alert
 * wrapper per Commandment 73 (no placeholder stubs). Pages don't
 * need to change; the helper now dispatches a CustomEvent that the
 * <TraceExplainerHost /> mounted in WorkspaceShell catches and
 * renders as a non-blocking modal popover.
 *
 * The name 'showAlertTrace' is preserved as a backward-compat alias
 * so the 18 page files continue to work; new code should import
 * `emitTraceExplanation` directly from `components/ui`.
 */
export function showAlertTrace(message: string): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent("solvait-trace-explain", {
      detail: { message },
    }),
  );
}
